import {
  Button,
  ButtonGroup,
  FormLabel,
  IconButton,
  Input,
  Popover,
  PopoverCloseButton,
  PopoverContent,
  PopoverTrigger,
  VStack,
  useDisclosure,
} from '@chakra-ui/react';
import createVideoPlugin from '@draft-js-plugins/video';
import { EditorState } from 'draft-js';
import * as React from 'react';

import { VideoIcon } from '@/imports/ui/chakra/feather';

const videoPlugin = createVideoPlugin();

export const VideoAdd: React.FC<{
  editorState: EditorState;
  onChange: (state: EditorState) => void;
}> = ({ editorState, onChange }) => {
  const { onOpen, onClose, isOpen } = useDisclosure();
  const [url, setUrl] = React.useState('');

  const onPopoverClose = () => {
    setUrl('');
    onClose();
  };

  return (
    <Popover isOpen={isOpen} onOpen={onOpen} onClose={onPopoverClose}>
      <PopoverTrigger>
        <IconButton
          aria-label="add video"
          icon={<VideoIcon />}
          variant="outline"
          colorScheme="gray"
        >
          Add Video
        </IconButton>
      </PopoverTrigger>
      <PopoverContent p="5">
        <PopoverCloseButton />
        <VStack w="full" spacing="4" alignItems="flex-start">
          <FormLabel>Paste a Video URL</FormLabel>
          <Input onChange={(e) => setUrl(e.target.value)} value={url} />
          <ButtonGroup w="full" display="flex" justifyContent="flex-end">
            <Button
              variant="outline"
              onClick={onPopoverClose}
              colorScheme="gray"
            >
              Cancel
            </Button>
            <Button
              onClick={() => {
                onChange(videoPlugin.addVideo(editorState, { src: url }));
                onPopoverClose();
              }}
              isDisabled={!url}
            >
              Add
            </Button>
          </ButtonGroup>
        </VStack>
      </PopoverContent>
    </Popover>
  );
};
